export default "__VITE_ASSET__CQxOUkk9__"